<template>
    <div class="zhima">
        <Header tit="芝麻信用授权" color="1"></Header>
        <div class="authorize-zhima-title">
            <img class="authorize-logo" src="@/assets/my/t1ndlgxethxxxxxxxx.jpg" />
        </div>
        <div class="protocol-auth-detail">
            <div calss="protocol-detail-title">点击「同意授权」即表示您已阅读并同意以下内容：</div>
            <div class="protocol-detail-content">
                <div class="protocol-detail-content">
                    <div class="protocol-detail-content-ul">
                        <div>您授权本平台在合法合规前提下，向合作机构查询、核验与您身份相关的必要信息（如姓名、证件号、手机号等），用于授信评估与风险控制。</div>
                        <div>您授权本平台查询与您相关的信用评估信息（如芝麻信用分等，以实际对接为准），用于综合评估您的信用状况。</div>
                        <div class="tit">特别提醒</div>
                        <div>如出现逾期或其他违约情形，可能影响您的信用记录，并影响后续借款等服务的申请与使用。</div>
                        <div>1. 在法律法规允许范围内，为核实履约情况，相关机构可能通过您预留的联系方式与您取得联系。</div>
                        <div>2. 违约信息可能被依法记录并共享给合作方，从而对您后续金融服务产生影响。</div>
                    </div>
                </div>
            </div>
        </div>
        <BigBtn label="同意授权" class="sq"></BigBtn>
        <div class="what_zhima gray_color" @click="$router.push({name:'what_zhima'})">什么是芝麻信用</div>
    </div>
</template>

<script>
import Header from "../public/header";
import BigBtn from "../public/button";
export default {
    components: { Header, BigBtn },
    data() {
        return {
            phone: "",
            code: "",
            code_count_down: 0,
            play: null
        };
    },
    beforeDestroy() {
        clearInterval(this.play);
    },
    methods: {
        click_BigBtn() {
            this.$router.push({ name: "zhima_sq" });
        }
    }
};
</script>

<style lang="scss" scoped>
.zhima {
    background: #ffffff;
    .authorize-zhima-title {
        width: 100%;
        height: 1.6rem;
        background: #fff;
        border-bottom: 2px solid #00c68d;
        padding-top: 0.3rem;
    }
    .authorize-logo {
        display: block;
        width: 3.3rem;
        margin: 0 auto;
    }
    .protocol-detail-content-ul div {
        margin-bottom: 10px;
    }
    .protocol-detail-content-ul .tit {
        font-weight: bold;
    }
    .protocol-auth-detail{
        padding-top: .2rem;
    }
    .sq {
        margin-top: 0.4rem;
    }
    .what_zhima {
        text-align: right;
        margin-top: 0.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/my/zhima.vue